import SelfServeBuilderSidePanelConstants from './SelfServeBuilderSidePanelConstants';

export const openPanel = panelType => (
  (dispatch) => {
    dispatch({
      type: SelfServeBuilderSidePanelConstants.SET_IS_OPEN,
      panelType,
      isOpen: true,
    });
  }
);

export const closePanel = panelType => (
  (dispatch) => {
    dispatch({
      type: SelfServeBuilderSidePanelConstants.SET_IS_OPEN,
      panelType,
      isOpen: false,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions.jsx